<template>
  <app-page-container custom="100%">
    <app-spinner v-if="!is_page_loaded" />
    <template v-else>
      <app-email-list-multiple-recipient
        v-for="(email, index) in reservations_emails"
        :key="email.id"
        :data="email"
        :count="index + 1"
      />
    </template>
  </app-page-container>
</template>

<script>
import AppEmailListMultipleRecipient from '@/components/AppEmailListMultipleRecipient.vue'
import { getReservationsEmails } from '@/http'

export default {
  name: 'ReservationMealEmails',
  components: { AppEmailListMultipleRecipient },
  data() {
    return {
      is_page_loaded: false,
      reservations_emails: []
    }
  },
  created() {
    this.getReservationsEmailsList()
  },
  methods: {
    getReservationsEmailsList() {
      getReservationsEmails({ meal_reservation_id: this.$route.params.id })
        .then(res => {
          this.reservations_emails = res.data
          this.is_page_loaded = true
        })
    },
  }
}
</script>
